export function fmtMoney(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

const MP_FEE_TYPE_LABELS = {
  mercadopago_fee: "Taxa XPay",
  financing_fee: "Parcelamento / financiamento",
  coupon_fee: "Cupom",
  shipping_fee: "Envio",
};

export function mpFeeTypeLabel(type, t) {
  const key = String(type || "").toLowerCase();
  return t(`passagensPage.mpFeeType_${key}`, {
    defaultValue: MP_FEE_TYPE_LABELS[key] || type || "—",
  });
}

export function mpPaymentMethodLabel(mpFee) {
  if (!mpFee) return "—";
  const parts = [mpFee.payment_type_id, mpFee.payment_method_id].filter(Boolean);
  return parts.length ? parts.join(" · ") : "—";
}

function parseMpFeeJson(raw) {
  if (raw == null) return null;
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(String(raw));
  } catch {
    return null;
  }
}

export function resolveMpFeeFromVenda(venda, payments = []) {
  if (venda?.mp_fee) return venda.mp_fee;
  const fromJson = parseMpFeeJson(venda?.mp_fee_json);
  if (fromJson) return fromJson;
  const withFee = [...(payments || [])].reverse().find((p) => p.mp_fee?.total_fee != null);
  return withFee?.mp_fee || null;
}

function mpFeeFromChargesDetails(mpFee) {
  const charges = Array.isArray(mpFee?.charges_details) ? mpFee.charges_details : [];
  if (!charges.length) return null;
  let total = 0;
  for (const c of charges) {
    const val = Number(c?.amounts?.original ?? c?.amount);
    if (Number.isFinite(val) && val > 0) total += Math.abs(val);
  }
  return total > 0 ? total : null;
}

export function resolveMpFeeAmount(venda, mpFee) {
  const efetiva = venda?.taxa_mp_efetiva;
  if (efetiva != null && Number.isFinite(Number(efetiva)) && Number(efetiva) > 0) {
    return Number(efetiva);
  }

  const cobrada = venda?.taxa_mp_cobrada;
  if (cobrada != null && cobrada !== "" && Number.isFinite(Number(cobrada)) && Number(cobrada) > 0) {
    return Number(cobrada);
  }

  const taxaMp = venda?.taxa_mp;
  if (taxaMp != null && taxaMp !== "" && Number.isFinite(Number(taxaMp)) && Number(taxaMp) > 0) {
    return Number(taxaMp);
  }

  const feeObj = mpFee || resolveMpFeeFromVenda(venda);
  if (feeObj?.total_fee != null && Number.isFinite(Number(feeObj.total_fee)) && Number(feeObj.total_fee) > 0) {
    return Number(feeObj.total_fee);
  }
  const fromCharges = mpFeeFromChargesDetails(feeObj);
  if (fromCharges != null) return fromCharges;

  if (cobrada != null && cobrada !== "" && Number.isFinite(Number(cobrada))) {
    return Number(cobrada);
  }

  return null;
}

export function isMpFeePending(venda) {
  if (!venda?.intermediated) return false;
  const mpId = String(venda.mp_payment_id || "").trim();
  if (!mpId) return false;
  const amount = resolveMpFeeAmount(venda);
  return amount == null || amount <= 0;
}
